export default __webpack_public_path__ + "static/retirement-planning-10-8db968cde1021370305c46f18c914a04.png";